function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    "custom_style":".punchout span.wsaio__checkout, .punchout a.btn.btn--secondary.cart__continue, .punchout div#shopify-installments { display: none; } .punchout .mini-cart-footer-actions button[name=\"checkout\"] { display: none !important; } .punchout .payment-terms-text, .punchout .shoppinggives-tag.roundup , .punchout .shoppinggives-tag.addon { display: none !important; }",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"cart-checkout-button button\" style=\"background-color:#043366; color:#ffffff; padding:1.4rem; border-radius:10px;\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>",
    "cart_transfer_metafields": [
      "custom.unspsc",
      "custom.uom"
    ],
    "graphql_token": "59775851fa2ac62b2540625938152290"
  };

  POExt = new Po2go_Shopify(store_config);
  POSession = new Po2go({
      'account':'',
      'punchout_only' : store_config.punchout_only,
      'extension' : POExt
  });
  POSession.init();
  POSession.extension.setupPage();
}